import { User } from '@shared/types'

export interface BackendUser {
  id: string
  email: string
  firstName: string
  lastName: string
  role: 'HR_ADMIN' | 'GENERAL_MANAGER' | 'BRANCH_MANAGER' | 'SYSTEM_ADMIN' | 'UNASSIGNED'
  branchId?: string | null
  createdAt: string
  updatedAt?: string
}

/**
 * Helper function to transform backend user to frontend user format
 */
export const transformUser = (backendUser: BackendUser): User => {
  // Map backend role format to frontend role format
  const roleMap: Record<BackendUser['role'], User['role']> = {
    'HR_ADMIN': 'hr_admin',
    'GENERAL_MANAGER': 'general_manager',
    'BRANCH_MANAGER': 'branch_manager',
    'SYSTEM_ADMIN': 'system_admin',
    'UNASSIGNED': 'unassigned'
  }

  return {
    id: backendUser.id,
    email: backendUser.email,
    firstName: backendUser.firstName,
    lastName: backendUser.lastName,
    role: roleMap[backendUser.role],
    branchId: backendUser.branchId || undefined
  }
} 